import {Component} from '@angular/core';

@Component({
  templateUrl: './legend-entry.component.html'
})
export class LegendEntryComponent {}
